import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SectionManuscriptsComponent } from './components/sections/section-manuscripts/section-manuscripts.component';
import { SectionBibliographyComponent } from './components/sections/section-bibliography/section-bibliography.component';
import { SectionCriticalEditionComponent } from './components/sections/section-critical-edition/section-critical-edition.component';
import { SectionProjectComponent } from './components/sections/section-project/section-project.component';
import { SectionSearchComponent } from './components/sections/section-search/section-search.component';
import { SectionDownloadsComponent } from './components/sections/section-downloads/section-downloads.component';
import { PageHomeComponent } from './components/pages/page-home/page-home.component';
import { PageLoginComponent } from './components/pages/page-login/page-login.component';
// import { PageManuscriptsComponent } from './components/pages/page-manuscripts/page-manuscripts.component';
import { PageManuscriptIntroComponent } from './components/pages/page-manuscript-intro/page-manuscript-intro.component';
import { PageManuscriptListComponent } from './components/pages/page-manuscript-list/page-manuscript-list.component';
import { PageManuscriptCardComponent } from './components/pages/page-manuscript-card/page-manuscript-card.component';
import { PageManuscriptTimelineComponent } from './components/pages/page-manuscript-timeline/page-manuscript-timeline.component';
import { PageBiblioListComponent } from './components/pages/page-biblio-list/page-biblio-list.component';
import { PageBiblioCardComponent } from './components/pages/page-biblio-card/page-biblio-card.component';
import { PageCriticalEditionViewComponent } from './components/pages/page-critical-edition-view/page-critical-edition-view.component';
import { PageCriticalEditionSamplesComponent } from './components/pages/page-critical-edition-samples/page-critical-edition-samples.component';
import { PageCriticalEditionStructureIntroComponent } from './components/pages/page-critical-edition-structure-intro/page-critical-edition-structure-intro.component';
import { PageCriticalEditionIntroComponent } from './components/pages/page-critical-edition-intro/page-critical-edition-intro.component';
import { PageCriticalEditionIntroWorkComponent } from './components/pages/page-critical-edition-intro-work/page-critical-edition-intro-work.component';
import { PageCriticalEditionTeiSchemaComponent } from './components/pages/page-critical-edition-tei-schema/page-critical-edition-tei-schema.component';
import { PageCriticalEditionTeiDownloadsComponent } from './components/pages/page-critical-edition-tei-downloads/page-critical-edition-tei-downloads.component';
import { PageInfoComponent } from './components/pages/page-info/page-info.component';
import { PageContactComponent } from './components/pages/page-contact/page-contact.component';
import { PageStemmaComponent } from './components/pages/page-stemma/page-stemma.component';
// import { PageSearchInfoComponent } from './components/pages/page-search-info/page-search-info.component';
import { PageSearchImagesComponent } from './components/pages/page-search-images/page-search-images.component';
import { PageDownloadsMssComponent } from './components/pages/page-downloads-mss/page-downloads-mss.component';
import { PageDownloadsIndirectComponent } from './components/pages/page-downloads-indirect/page-downloads-indirect.component';
import { PageDownloadsIntroComponent } from './components/pages/page-downloads-intro/page-downloads-intro.component';
import { PageDownloadsCataloguesComponent } from './components/pages/page-downloads-catalogues/page-downloads-catalogues.component';
import { PageSearchEditionComponent } from './components/pages/page-search-edition/page-search-edition.component';
import { PageTermsOfUseComponent } from './components/pages/page-terms-of-use/page-terms-of-use.component';
import { PageProjectIntroComponent } from './components/pages/page-project-intro/page-project-intro.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';

const routes: Routes = [
    {
        path: '',
        component: PageHomeComponent,
        pathMatch: 'full',
        data: {
            breadcrumb: 'Home'
        }
    },
    {
        path: 'login',
        component: PageLoginComponent
    },
    {
        path: 'manuscripts',
        component: SectionManuscriptsComponent,
        data: {
            breadcrumb: 'Manuscripts'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list'
//                component: PageManuscriptsComponent,
//                data: {
//                    breadcrumb: 'Info'
//                }
            },
            {
                path: 'intro',
                component: PageManuscriptIntroComponent,
                data: {
                    breadcrumb: 'Introduction'
                }
            },
            {
                path: 'list',
                component: PageManuscriptListComponent,
                data: {
                    breadcrumb: 'Catalogue'
                }
            },
            {
                path: 'list/:manId',
                component: PageManuscriptCardComponent,
                data: {
                    breadcrumb: 'Card'
                }
            },
            {
                path: 'timeline',
                component: PageManuscriptTimelineComponent,
                data: {
                    breadcrumb: 'Timeline'
                }
            },
            {
                path: 'timeline/:manId',
                component: PageManuscriptCardComponent,
                data: {
                    breadcrumb: 'Card'
                }
            },
            {
                path: 'images',
                component: PageSearchImagesComponent,
                data: {
                    breadcrumb: 'Search by images'
                }
            },
            {
                path: 'images',
                component: PageSearchImagesComponent,
                data: {
                    breadcrumb: 'Search by images'
                }
            },
        ]
    },
    {
        path: 'bibliography',
        component: SectionBibliographyComponent,
        data: {
            breadcrumb: 'Bibliography'
        },
        children: [
            {
                path: '',
                component: PageBiblioListComponent,
                data: {
                    breadcrumb: 'Search'
                }
            },
            {
                path: ':bibId',
                component: PageBiblioCardComponent,
                data: {
                    breadcrumb: 'Card'
                }
            }
        ]
    },
    {
        path: 'edition',
        component: SectionCriticalEditionComponent,
        data: {
            breadcrumb: 'Edition'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'workintro'
            },
            {
                path: 'workintro',
                component: PageCriticalEditionIntroWorkComponent,
                data: {
                    breadcrumb: 'Introduction to the Edited Work'
                }
            },
            {
                path: 'intro',
                component: PageCriticalEditionIntroComponent,
                data: {
                    breadcrumb: 'Introduction to the Edition'
                }
            },
            {
                path: 'search',
                component: PageSearchEditionComponent,
                data: {
                    breadcrumb: 'Search'
                }
            },
            {
                path: 'tei',
                data: {
                    breadcrumb: 'TEI Version'
                },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'schema'
                    },
                    {
                        path: 'schema',
                        component: PageCriticalEditionTeiSchemaComponent,
                        data: {
                            breadcrumb: 'PhiBor Schema Customization'
                        }
                    },
                    {
                        path: 'downloads',
                        component: PageCriticalEditionTeiDownloadsComponent,
                        data: {
                            breadcrumb: 'Downloads'
                        }
                    }
                ]
            },
            {
                path: 'samples',
                component: PageCriticalEditionSamplesComponent,
                data: {
                    breadcrumb: 'Collection samples'
                }
            },
            {
                path: 'sample/:cedId',
                component: PageCriticalEditionViewComponent,
                data: {
                    breadcrumb: 'View sample'
                }
            },
            {
                path: ':cedId/intro',
                component: PageCriticalEditionStructureIntroComponent,
                data: {
                    breadcrumb: 'Introduction'
                }
            },
            {
                path: ':cedId/text',
                component: PageCriticalEditionViewComponent,
                data: {
                    breadcrumb: 'Text'
                }
            }
        ]
    },
    {
        path: 'project',
        component: SectionProjectComponent,
        data: {
            breadcrumb: 'Info'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'intro'
//                component: PageManuscriptIntroComponent,
//                data: {
//                    breadcrumb: 'Introduction to Avicenn@'
//                }
            },
            {
                path: 'intro',
                component: PageProjectIntroComponent,
                data: {
                    breadcrumb: 'Introduction to Avicenn@'
                }
            },
            {
                path: 'credits',
                component: PageInfoComponent,
                data: {
                    breadcrumb: 'Credits'
                }
            },
            {
                path: 'contact',
                component: PageContactComponent,
                data: {
                    breadcrumb: 'Contacts'
                }
            },
            {
                path: 'terms',
                component: PageTermsOfUseComponent,
                data: {
                    breadcrumb: 'Terms of use'
                }
            }
        ]
    },
    {
        path: 'stemma',
        component: PageStemmaComponent,
        data: {
            breadcrumb: 'Stemma'
        }
    },
//    {
//        path: 'search',
//        component: SectionSearchComponent,
//        data: {
//            breadcrumb: 'Search'
//        },
//        children: [
//            {
//                path: '',
//                component: PageSearchInfoComponent,
//                data: {
//                    breadcrumb: 'Info'
//                }
//            },
//            {
//                path: 'images',
//                component: PageSearchImagesComponent,
//                data: {
//                    breadcrumb: 'Images'
//                }
//            },
//            {
//                path: 'edition',
//                component: PageSearchEditionComponent,
//                data: {
//                    breadcrumb: 'Edition'
//                }
//            }
//        ]
//    },
    {
        path: 'downloads',
        component: SectionDownloadsComponent,
        data: {
            breadcrumb: 'Other Resources'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'intro'
            },
            {
                path: 'intro',
                component: PageDownloadsIntroComponent,
                data: {
                    breadcrumb: 'Introduction'
                }
            },
            {
                path: 'mss',
                component: PageDownloadsMssComponent,
                data: {
                    breadcrumb: 'All Šifāʾ Manuscripts'
                }
            },
            {
                path: 'indirect',
                component: PageDownloadsIndirectComponent,
                data: {
                    breadcrumb: 'Indirect Tradition'
                }
            },
            {
                path: 'catalogues',
                component: PageDownloadsCataloguesComponent,
                data: {
                    breadcrumb: 'Catalogues'
                }
            }
        ]
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts